"use client";

import { Button } from "@/shared/ui/button";
import { Ico24Download } from "@/shared/assets/icons/ico_24_download";
import { useTranslations } from "next-intl";

export function DownloadCard({ isLoggedIn }: { isLoggedIn: boolean }) {
  const t = useTranslations();

  return (
    <div className="w-full max-w-[1280px]">
      <div className="mb-20 flex w-full flex-col">
        <h1 className="heading-1 mb-5 text-gray-900">{t("f_sd_title")}</h1>
        <span className="body-lg-regular text-gray-700">{t("f_sd_context_1")}</span>
      </div>
      <div className="rounded-24 flex items-center justify-center gap-10 border border-gray-100 px-10 py-25">
        <div className="flex flex-1 flex-col items-center justify-center">
          <h1 className="heading-1 mb-2 text-gray-900">{t("f_sd_title_1")}</h1>
          <h4 className="heading-4-regular mb-5 text-center whitespace-pre-line text-gray-900">{t("f_sd_title_2")}</h4>

          <Button variant="primary" size="lg" className="gap-[6px]" disabled={true}>
            Download <Ico24Download className="size-6" />
          </Button>
        </div>
        <div className="w-[1px] self-stretch bg-gray-100" />
        <div className="flex flex-1 flex-col items-center justify-center">
          <h1 className="heading-1 mb-2 text-gray-900">{t("f_sd_title_3")}</h1>
          <h4 className="heading-4-regular mb-5 text-center whitespace-pre-line text-gray-900">{t("f_sd_title_4")}</h4>

          <Button variant="primary" size="lg" className="gap-[6px]" disabled={true}>
            Download <Ico24Download className="size-6" />
          </Button>
        </div>
      </div>
    </div>
  );
}
